<div class="search-form-wrapper"
    role="search"
>
    <form class="ops-form">
        <div class="search__box"
             matAutocompleteOrigin
             #origin="matAutocompleteOrigin"
             
             [ngClass]="{ 'show-full': this.searchControl.disabled,
                          'searching-state': showAutocomplete,
                          'compact': this.isCompact,
                          }"
             (focus)="onSearchBoxFocus($event)"
        >
            <mat-icon class="search__icon">
                search
            </mat-icon>

            <input
                    #searchInput
                    class="search__input"
                    type="text"
                    placeholder="Find Vehicle, Route or Address"
                    aria-label="Number"
                    matInput
                    [formControl]="searchControl"
                    [matAutocomplete]="auto"
                    [matAutocompleteConnectedTo]="origin"
                    (focus)="onFocus($event)"
                    (keyup.enter)="onPressEnter($event)"
                    (focusout)="onFocusOut($event)"
            />

            @if (searchControl.dirty) {
              <button mat-icon-button
                      class="clear__button"
                      (click)="clearSearch()"
                      aria-label="close"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
        </div>

        <mat-autocomplete autoActiveFirstOption
                          #auto="matAutocomplete"
                          class="search-autocomplete"
                          [displayWith]="displayFn"
                          [panelWidth]="380"
        >
            <mat-optgroup [label]="'Vehicles'"
                          [ngClass]="{ 'hide-autocomplete': !showAutocomplete }">
              @for (asset of filteredAssets$ | async; track $index) {
                <mat-option
                  [value]="{type: SearchResultType.VEHICLE, result: asset}"
                  (click)="vehicleSelected(asset)"
                  class="autocomplete-option"
                >
                  <div class="autocomplete-line">
                    <div class="autocomplete-primary flex-row justify-content-space-between align-items-center">
                      <mat-icon>
                        directions_car
                      </mat-icon>
                      <span class="autocomplete-primary-text vehicle-option"
                            [matTooltip]="asset.name.length > 28 ? asset.name : undefined"
                      >
                            {{ asset.name }}
                          </span>
                    </div>

                    <span class="mat-small">{{ AssetStatus.getAssetStatus(asset) }}</span>
                  </div>
                </mat-option>
              }
            </mat-optgroup>

            @if (!!routeSuggestions && routeSuggestions.length > 0) {
              <mat-optgroup [label]="'Routes'"
                            [ngClass]="{ 'hide-autocomplete': !showAutocomplete }"
              >
                @for (suggestion of routeSuggestions; track $index) {
                  <mat-option
                    [value]="{type: SearchResultType.ROUTE, result: suggestion}"
                    (click)="routeSelected(suggestion)"
                    class="autocomplete-option"
                  >
                    <div class="autocomplete-line">
                      <div class="autocomplete-primary flex-row align-items-center">
                        <mat-icon>
                          routes
                        </mat-icon>

                        <span class="autocomplete-primary-text">{{ suggestion.value }}</span>
                      </div>
                    </div>
                  </mat-option>
                }
              </mat-optgroup>
            }

            @if (!!addressSuggestions && addressSuggestions.length > 0) {
              <mat-optgroup [label]="'Addresses'"
                            [ngClass]="{ 'hide-autocomplete': !showAutocomplete }"
              >
                @for (suggestion of addressSuggestions; track $index) {
                  <mat-option
                    [value]="{type: SearchResultType.ADDRESS, result: suggestion}"
                    (click)="addressSelected(suggestion)"
                    class="autocomplete-option"
                  >
                    <div class="autocomplete-line">
                      <div class="autocomplete-primary flex-row align-items-center">
                        <mat-icon>
                          home
                        </mat-icon>

                        <span class="autocomplete-primary-text"
                              [matTooltip]="suggestion.text.length > 36 ? suggestion.text : undefined"
                        >
                            {{ suggestion.text }}
                          </span>
                      </div>
                    </div>
                  </mat-option>
                }
              </mat-optgroup>
            }

            @if (configuration && hasFeatureFlag(FeatureFlagEnum.Poi) && pois.length > 0) {
              <mat-optgroup [label]="'POI'">
                @for (poi of pois; track $index) {
                  <mat-option
                    [ngClass]="{ 'hide-autocomplete': !showAutocomplete }"
                    [value]="{type: SearchResultType.POI, result: poi}"
                    (click)="poiSelected(poi)"
                  >
                    <div class="autocomplete-line">
                      <div class="autocomplete-primary flex-row align-items-center">
                        <mat-icon>
                          {{ getPoiIconName() }}
                        </mat-icon>

                        <span class="autocomplete-primary-text">{{ poi.name }}</span>
                      </div>
                    </div>
                  </mat-option>
                }
              </mat-optgroup>
            }

        </mat-autocomplete>
    </form>
</div>
